(ns ui.view.card.risks.sub
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [ui.view.card.entity-list.util :as entity-list-util]
   [common.util :as cu]))

(defn risk? [entity]
  ;;TODO other than holding risks:
  (= (:entity/type entity) :entity.type/risk-holding))

(rf/reg-sub
 ::risks
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)
         primary-entity (get card-entities-by-id primary-entity-id)
         risks (->> primary-entity
                    ;;TODO other than holding risks:
                    :holding/risks
                    (keep card-entities-by-id)
                    (remove :common/disabled?))]
     risks)))

(rf/reg-sub
 ::risks-count
 (fn [[_ ctx]]
   [(rf/subscribe [::risks ctx])])
 (fn [[risks]]
   (count risks)))

(rf/reg-sub
 ::table-data
 (fn [[_ ctx]]
   [(rf/subscribe [::risks ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/entities])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[risks
       card-entities-by-id
       global-entities-by-id
       tenant
       tenant-schema]
      [_ {:keys [card] :as _ctx}]]
   (let [all-entities-by-id (merge global-entities-by-id card-entities-by-id)
         column-fields (->> card
                            :card/config
                            :table
                            :columns
                            (mapv :field))]
     (entity-list-util/entities->table-row-data
      {:entities risks
       :column-fields column-fields
       :entities-by-id all-entities-by-id
       :tenant tenant
       :tenant-schema tenant-schema}))))

;; FIXME: field permissions?
;; TODO deletion via risk-editor modal => this can be removed?
(rf/reg-sub
 ::delete-risk-helper-text
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/delete-confirmation-entity-id ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])
    (rf/subscribe [::session-sub/entities])])
 (fn [[delete-confirmation-entity-id card-entities-by-id
       tenant tenant-schema global-entities-by-id]]
   (let [risk (get card-entities-by-id delete-confirmation-entity-id)
         get-materialized-value (fn [field]
                                  (uu/field-value->materialized-value
                                   {:field field
                                    :value (get risk field)
                                    :tenant tenant
                                    :tenant-schema tenant-schema
                                    :id->entity (merge global-entities-by-id
                                                       card-entities-by-id)
                                    :entity risk
                                    :show-currency? true}))
         status (get-materialized-value :risk/status)
         title(get-materialized-value :risk/title)
         show-part? (fn [materialized-value]
                      (not (cu/blank-value? materialized-value)))]
     ;; TODO: Add localization once confirmed with PO
     ;; TODO copy-pasted from fee - fix:
     (str "You are about to delete a"
          (if (show-part? status)
            (str " " status " risk")
            " risk")
          (when (show-part? title)
            (str " paid by " title))
          ""))))
